const aleatorio = () => {
  const aleat = Math.floor(Math.random() * 999);
  //o preenchimento dos zeros ÃƒÂ  esquerda ÃƒÂ© mais facil com a funÃƒÂ§ÃƒÂ£o padStart da string
  return ("" + aleat).padStart(3, '0');
}

//function mod(dividendo,divisor){
//  return Math.round(dividendo - (Math.floor(dividendo/divisor)*divisor));
//  }


function GerarCNPJ() {
  let cnpj = '';
  const numeros = '0123456789';

  for (let i = 0; i < 12; i++) {
    cnpj += numeros.charAt(Math.floor(Math.random() * numeros.length));
  }

  // Calculo do primeiro dígito verificador
  let soma = 0;
  let peso = 2;
  for (let i = 11; i >= 0; i--) {
    soma += parseInt(cnpj.charAt(i)) * peso;
    peso++;
    if (peso > 9) {
      peso = 2;
    }
  }
  let resto = soma % 11;
  if (resto < 2) {
    cnpj += 0;
  } else {
    cnpj += 11 - resto;
  }

  // Calculo do segundo dígito verificador
  soma = 0;
  peso = 2;
  for (let i = 12; i >= 0; i--) {
    soma += parseInt(cnpj.charAt(i)) * peso;
    peso++;
    if (peso > 9) {
      peso = 2;
    }
  }
  resto = soma % 11;
  if (resto < 2) {
    cnpj += 0;
  } else {
    cnpj += 11 - resto;
  }

  return cnpj;
}


const dig = (n1, n2, n3, n4) => {

  //as concatenaÃƒÂ§ÃƒÂµes todas juntas uma vez que sÃƒÂ£o curtas e legÃƒÂ­veis
  const nums = n1.split("").concat(n2.split(""), n3.split(""));

  if (n4 !== undefined) { //se for o segundo digito coloca o n4 no sitio certo
    nums[9] = n4;
  }

  let x = 0;

  //o j ÃƒÂ© tambÃƒÂ©m iniciado e incrementado no for para aproveitar a prÃƒÂ³pria sintaxe dele
  //o i tem inicios diferentes consoante ÃƒÂ© 1Ã‚Âº ou 2Ã‚Âº digito verificador
  for (let i = (n4 !== undefined ? 11 : 10), j = 0; i >= 2; i--, j++) {
    x += parseInt(nums[j]) * i;
  }

  const y = x % 11;
  //ternÃƒÂ¡rio aqui pois ambos os retornos sÃƒÂ£o simples e continua legivel
  return y < 2 ? 0 : 11 - y;
}

const CPFEhValido = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  let sum = 0;
  let remainder;

  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.substring(9, 10))) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.substring(10, 11))) return false;

  return true;
};

function formatarInteiro(valor) {
  valor = valor.replace(/\D/g, "") // permite digitar apenas numero
  return valor;
}

const RetornaSoNumeros = (str) => {
  if ((str) && (str.trim()) === '') {
    return str.replace(/\D/g, '');
  } else {
    return '';
  }

};

const GerarCPF = () => {
  const num1 = aleatorio(); //aleatorio jÃƒÂ¡ devolve string, logo nÃƒÂ£o precisa de toString
  const num2 = aleatorio();
  const num3 = aleatorio();

  const dig1 = dig(num1, num2, num3); //agora sÃƒÂ³ uma funÃƒÂ§ÃƒÂ£o dig
  const dig2 = dig(num1, num2, num3, dig1); //mesma funÃƒÂ§ÃƒÂ£o dig aqui

  //aqui com interpolaÃƒÂ§ÃƒÂ£o de strings fica bem mais legivel
  return `${num1}.${num2}.${num3}-${dig1}${dig2}`;
}

function formatarMoeda(valor) {
  const formatado = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor);
  return formatado;
}


const formatarCPF = (value) => {
  value = value.replace(/\D/g, ''); // Remove tudo que não é dígito
  value = value.replace(/(\d{3})(\d)/, '$1.$2'); // Coloca um ponto entre o terceiro e o quarto dígitos
  value = value.replace(/(\d{3})(\d)/, '$1.$2'); // Coloca um ponto entre o sexto e o sétimo dígitos
  value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); // Coloca um hífen entre o nono e o décimo dígitos
  return value;
};

function formatarCNPJ(cnpj) {
  cnpj = cnpj.replace(/\D/g, ""); // Remove tudo que não for número

  if (cnpj.length !== 14) {
    return formatarCPF(cnpj); // Verifica se tem 14 dígitos
  }

  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
}

const retornaDataHoraAtual = () => {
  const agora = new Date();
  const formatarComDoisDigitos = (n) => (n < 10 ? '0' + n : n);

  const dia = formatarComDoisDigitos(agora.getDate());
  const mes = formatarComDoisDigitos(agora.getMonth() + 1); // Janeiro Ã© 0
  const ano = agora.getFullYear();

  const horas = formatarComDoisDigitos(agora.getHours());
  const minutos = formatarComDoisDigitos(agora.getMinutes());

  return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
}

const tratarErros = (erro) => {
  if (erro.toLowerCase().includes('network error')) {
    return 'Servidor temporariamente fora do ar'
  }
  else if (erro.toLowerCase().includes('code 401')) {
    return 'O servidor informou que o recurso solicitado não existe'
  }
  else return erro;
}

const abrirOrcamentoWhats = (categoria) => {
  const numero = '5571999556884';
  const mensagem = `Olá, gostaria de fazer um orçamento para ${categoria}`;

  // ENVIANDO PARA O GOOGLE ANALYTICS
  if (window.gtag) {
    window.gtag('event', 'interacao_whatsapp', {
      'event_category': 'Engagement',
      'event_label': categoria, // Aqui ele vai dizer se foi 'jogos', 'chave', etc.
      'page_title': document.title, // Pega o título que você já definiu no useEffect
      'page_location': window.location.href,
      'value': 1
    });
  }
  window.open(`https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`, '_blank');
};

const trazerRodapePaginasProdutos = (categoria) => {
  return `Consulte a unidade mais próxima para conhecer toda a linha de ${categoria}.`;
}

const trazerTituloProdutos = () => {
  return `Alguns itens desta categoria`;
}

const trazerTituloServicos = (categoria) => {
  return `A Trinco oferece serviços especializados em ${categoria} nas lojas e na Trinco+, 
  disponíveis nas unidades em Salvador, Lauro de Freitas e Feira de Santana.`;
}

const trazerRodapePaginasServicos = (categoria) => {
  return `Consulte a unidade mais próxima para avaliação, orçamento e outros ${categoria}.`;
}



export {
  CPFEhValido, retornaDataHoraAtual, formatarInteiro, RetornaSoNumeros, formatarMoeda, formatarCPF,
  formatarCNPJ, GerarCPF, GerarCNPJ, tratarErros, abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos,
  trazerRodapePaginasServicos, trazerTituloServicos
}